import React, { useState, useEffect } from 'react';
import { format, addDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import './index.css';

const DateSelector = ({ selectedDate, onDateChange, onPrevDay, onNextDay }) => {
  const [weekDates, setWeekDates] = useState([]);

   const generateWeekDates = () => {
      const dates = [];
      const today = new Date();
      for (let i = -3; dates.length < 31; i++) {
        const date = addDays(today, i);
        if (date.getDay() !== 0) { 
          dates.push(date);
        }
      }
      setWeekDates(dates);
  };

  useEffect(() => {
    generateWeekDates();
  }, []);

  const formatDate = (date) => format(date, 'dd/MM/yyyy (EEEE)', { locale: ptBR });

  const selectedDateIndex = weekDates.findIndex(
    (date) => date.toDateString() === selectedDate.toDateString()
  );

  return (
    <div className="date-selector">
      <button
        className="btn prev-btn"
        onClick={onPrevDay}
        disabled={selectedDateIndex === 0} 
      >
        &lt;
      </button>
      <select
        className="form-select"
        value={selectedDate.toDateString()}
        onChange={(e) => onDateChange(new Date(e.target.value))}
      >
        {weekDates.map((date, index) => (
          <option key={index} value={date.toDateString()}>
            {formatDate(date)}
          </option>
        ))}
      </select>
      <button
        className="btn next-btn"
        onClick={onNextDay}
        disabled={selectedDateIndex === weekDates.length - 1} 
      >
        &gt;
      </button>
    </div>
  );
};

export default DateSelector;
